const Types = {
  CLEAR: "@@find-jobs-filters/CLEAR",
  SET: "@@find-jobs-filters/SET",
};

export { Types };
export default Types;
